import { Component, OnInit, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NavigationService } from '../../../core/services/navigation.service';
import { MainMenuItem } from '../../../core/models/navigation.types';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  isMenuOpen = false;
  currentLevel = 1;
  currentSection = '';
  mainMenuItems: MainMenuItem[] = [];

  constructor(private navigationService: NavigationService) {}

  ngOnInit() {
    this.mainMenuItems = this.navigationService.getMainMenu();
  }

  public getCurrentSection(): MainMenuItem | null {
    if (!this.currentSection) return null;
    return this.mainMenuItems.find(item => item.id === this.currentSection) || null;
  }

  @HostListener('window:resize')
  onResize() {
    if (window.innerWidth > 768) {
      this.closeMenu();
    }
  }

  @HostListener('window:scroll', ['$event'])
  onScroll() {
    if (this.isMenuOpen) {
      event?.preventDefault();
    }
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
    this.updateBodyScroll();
  }

  closeMenu() {
    this.isMenuOpen = false;
    this.currentLevel = 1;
    this.currentSection = '';
    this.updateBodyScroll();
  }

  navigateToSection(sectionId: string) {
    this.currentSection = sectionId;
    this.currentLevel = 2;
  }

  goBack() {
    if (this.currentLevel > 1) {
      this.currentLevel = 1;
      this.currentSection = '';
    } else {
      this.closeMenu();
    }
  }

  private updateBodyScroll() {
    document.body.style.overflow = this.isMenuOpen ? 'hidden' : '';
  }
}